import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { CostUnitGroupContributionMarginLevelAssignmentsDialogComponent } from './cost-unit-group-contribution-margin-level-assignments.dialog.component';

export * from './cost-unit-group-contribution-margin-level-assignments.dialog.component';
@NgModule({
    declarations: [ CostUnitGroupContributionMarginLevelAssignmentsDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        TranslateModule,
        MatTableModule,
        MatIconModule,
        MatProgressBarModule,
        MatSortModule,
        MatPaginatorModule,
    ],
})
export class CostUnitGroupContributionMarginLevelAssignmentsDialogModule {
}
